import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// helpers
import useNotifications from '../../../../../_lib/notifications/useNotifications';
// mui
import { Box, Card as MuiCard, Divider, Grid as MuiGrid } from '@mui/material';
import { styled, makeStyles } from '@mui/styles';
// utils
import { PubSub } from '../../../../../utils/eventUtils';
// components
import withRouter from '../../../../../components/hocs/withRouter';
import P250SecurityQuestions from '../../../../../components/main/settings/orgProfile/P250SecurityQuestions';
import { OrganizationContact } from '../../../../../public/quote/confirm/OrganizationContact';
import { OtherQuestions } from '../../../../../components/main/settings/orgProfile/OtherQuestions';
import { AccountDetails } from '../../../../../public/quote/confirm/AccountDetails';
import CustomerRenewalAttestSubmit from '../../prime100/policyholder/CustomerRenewalAttestSubmit';

export const CustomerPrime250WithRenewalChanges = withRouter(
  ({ data = {}, onMovingAhead }: any) => {
    const { rawQuote: quote, formattedQuote } = data;
    const notifications = useNotifications();
    const { push } = useHistory();
    const classes = useStyles();

    const [invalidQuote, setInvalid] = useState(false);

    const { isRenewal, isMigration, firmographicData, accountId } = quote;
    const isQuoteRenewal = isRenewal || isMigration;

    useEffect(() => {
      const invQ = PubSub.subscribe('quote-invalidated', (value: any) => {
        setInvalid(value);
      });

      const refQ = PubSub.subscribe('fetch-details', () => {
        // callQuoteDetails();
      });

      return () => {
        invQ.remove();
        refQ.remove();
      };
      // eslint-disable-next-line
    }, []);

    if (invalidQuote) {
      setTimeout(() => {
        push('/customer/policies');
        notifications.success(
          'Quote changes must go through Underwriter review, please wait!'
        );
      }, 2000);
    }

    return (
      <section>
          <MuiCard>
            <Box pl={3} pr={3} pb={3}>
              <MuiGrid container>
                <MuiGrid item md={10}>
                  <MuiDivider />
                  <AccountDetails
                    parentClasses={classes.card}
                    account={firmographicData}
                    accountId={accountId}
                    quote={quote}
                    from="attestation"
                    route="customer"
                  />
                </MuiGrid>
                <MuiGrid item md={10}>
                  <MuiDivider />
                  <OrganizationContact
                    parentClasses={classes.card}
                    data={quote}
                    accountId={accountId}
                    readOnly
                    route="customer"
                    from="attestation"
                  />
                </MuiGrid>
                <MuiGrid item md={10}>
                  <MuiDivider />

                  <P250SecurityQuestions
                    parentClasses={classes.card}
                    data={firmographicData}
                    from="attestation"
                    accountId={accountId}
                    isWithinExpiryPeriod={isQuoteRenewal}
                  />
                </MuiGrid>

                <MuiGrid item md={10}>
                  <MuiDivider />
                  <OtherQuestions
                    parentClasses={classes.card}
                    accountId={accountId}
                    data={quote}
                    from="attestation"
                    quote={quote}
                    route="customer"
                  />
                </MuiGrid>

                <CustomerRenewalAttestSubmit
                  data={formattedQuote}
                  onMovingAhead={onMovingAhead}
                />
              </MuiGrid>
            </Box>
          </MuiCard>
        </section>
    );
  }
);

const MuiDivider = styled(Divider)(() => ({
  margin: '2rem 0',
}));

const useStyles = makeStyles(({ config, palette }) => ({
  headings: {
    margin: 0,
    marginTop: '2rem',
    fontSize: config.textSizes.canon,
    lineHeight: 1,
    textAlign: 'left',
    color: `${palette.primary.contrastText} !important`,
    fontWeight: config.weights.bold,
  },
  card: {
    padding: '1.6666666667rem',
    border: '1px solid #707070',
    backgroundColor: 'rgba(38, 38, 46, .5)',
    color: 'white',
  },
}));
